import { createFileRoute, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Footer, MarketingHeader, SEO } from '@/components';
import { ChildSupportCalculator } from '@/components/child-support/ChildSupportCalculator';
import { track } from '@/lib/analytics';
import {
  getChildSupportPageDescription,
  getChildSupportPageTitle,
  getStateConfigBySlug,
  isStateSlug,
} from '@/lib/child-support/schemas';

export const Route = createFileRoute('/child-support-calculator/$state')({
  beforeLoad: ({ params }) => {
    if (!isStateSlug(params.state)) {
      throw redirect({ to: '/child-support-calculator' });
    }
  },
  component: ChildSupportStatePage,
});

function ChildSupportStatePage() {
  const { state } = Route.useParams();
  const stateConfig = getStateConfigBySlug(state);
  if (!stateConfig) return null;

  useEffect(() => {
    track('Child Support State Page View', { state });
  }, [state]);

  return (
    <div className='min-h-screen bg-white'>
      <SEO
        title={`${getChildSupportPageTitle(stateConfig)} | Harbor`}
        description={getChildSupportPageDescription(stateConfig)}
        path={`/child-support-calculator/${state}`}
      />
      <MarketingHeader />

      <section className='bg-primary/5 pt-32 pb-10'>
        <div className='mx-auto max-w-4xl px-6'>
          <h1 className='mb-3 text-4xl font-bold text-gray-900 md:text-5xl'>
            {stateConfig.name} child support calculator
          </h1>
          <p className='text-lg leading-relaxed text-gray-600 md:text-xl'>
            Quick estimate for {stateConfig.name}. This calculator is a rough educational model and
            not legal advice.
          </p>
        </div>
      </section>

      <div className='mx-auto max-w-7xl px-6 py-12'>
        <ChildSupportCalculator defaultStateSlug={state} />
      </div>

      <Footer />
    </div>
  );
}
